module.exports = __webpack_public_path__ + "static/media/banner-3@2x@2x.5bca6a93.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner-3@2x@2x.png
// module id = 573
// module chunks = 1